import { render } from "./HistoriquePatient.vue?vue&type=template&id=2933dcf5&scoped=true"
import script from "./HistoriquePatient.vue?vue&type=script&lang=js"
export * from "./HistoriquePatient.vue?vue&type=script&lang=js"

import "./HistoriquePatient.vue?vue&type=style&index=0&id=2933dcf5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2933dcf5"]])

export default __exports__